import { useEffect, useState } from 'react';
import { i18n } from '@/i18n-config';
import {
  countries as countryData,
  CountryType,
  languages,
  LanguageType,
} from '@/constant/localeData';
import { useParams } from 'next/navigation';

type Default = {
  country: CountryType | null;
  lang: LanguageType | null;
};

const useLocaleChange = () => {
  const params = useParams();

  const [defaultLocale, setDefaultLocale] = useState<Default>({
    country: null,
    lang: null,
  });

  useEffect(() => {
    if (params?.locale) {
      const [currentLng, currentCountry] =
        typeof params.locale === 'string' ? params.locale.split('-') : [];
      const defaultCountry =
        countryData.find((item: CountryType) => item.code === currentCountry) ??
        null;
      const defaultLang =
        languages.find((item: LanguageType) => item.key === currentLng) ?? null;
      setDefaultLocale({
        country: defaultCountry,
        lang: defaultLang,
      });
    }
  }, []);

  const changeLanguage = (lang: string) => {
    const currentUrl =
      window.location.pathname + window.location.search + window.location.hash;
    i18n.locales.forEach((value) => {
      if (currentUrl.startsWith(`/${value}`)) {
        const newUrl =
          currentUrl.slice(0, 1) + lang + currentUrl.slice(1 + lang.length);
        window.location.href = newUrl;
      }
    });
  };

  const changeCountry = (countryCode: string) => {
    const currentUrl =
      window.location.pathname + window.location.search + window.location.hash;
    i18n.locales.forEach((value) => {
      if (currentUrl.startsWith(`/${value}`)) {
        const newUrl =
          currentUrl.slice(0, 4) +
          countryCode +
          currentUrl.slice(4 + countryCode.length);
        window.location.href = newUrl;
      }
    });
  };

  return { changeLanguage, changeCountry, defaultLocale };
};

export default useLocaleChange;
